import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Col,
    Row
} from "reactstrap";
import styles from './styles.module.scss';
import Link from "next/link"

export default function BlogItem({
    news,
    customClass = "",
}) {

    return (
        <section className={`${styles.root} ${customClass}`}>
            <Container>
                <Row>
                    <Col md={5} className="pe-md-5 mb-5 mb-md-0">
                        <div className="pe-md-5">
                            <div className="img-wrapper rounded-3 overflow-hidden shadow">
                                <SourceFlowImage
                                    src={news?.image ? news.image : "/site-assets/images/image-placeholder.webp"}
                                    size="1000x1000"
                                    alt={news?.title}
                                    className="card-img"
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md={7}>
                        {news?.content ?
                            <div className="description" dangerouslySetInnerHTML={{ __html: news?.content }} />
                            : ""}
                    </Col>
                </Row>
            </Container>
        </section >

    )
}